export const PRICING_SLICE_NAME = "pricing"

export const PRICING_TAB = {
  ALERTS: "alerts",
  LOOKUPS: "lookups"
}

export const getPricingPreferencesFeature = (tab) => `pricing_${tab}`

// Where CHA1-1987 saved the Alerts table before the page had tabs, as
// `{ version: 1, filters, columnsAdmin, visibleFiltersAdmin }`.
export const LEGACY_PRICING_PREFERENCES_FEATURE = "pricing"

// Bump when the shape of the saved `{ version, filters, visibleFilters }` payload changes.
export const PRICING_PREFERENCES_VERSION = 1
